export default "__VITE_ASSET__3aa6a363__"